import { SxProps, Theme } from '@mui/material';
import { themeLight } from '@resurs-internal/mui';
import styled from 'styled-components';

// `Root` and `Wrapper` below are styled-components, which has its own theme
// context and cannot read the MUI ThemeProvider — hence the direct themeLight
// reference. RootPage mounts themeLight unconditionally, so this is accurate,
// but it is NOT theme-reactive: Storybook's dark-theme toggle will not affect
// these two. `RootBoxStyles` is MUI sx and does read the provider.
export const Root = styled.div`
    position: relative;
    color: ${themeLight.palette.grey[900]};
    background-color: ${themeLight.palette.grey[50]};
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const RootBoxStyles = (theme: Theme): SxProps<Theme> => ({
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '48px 20px 80px 20px',
    minHeight: 'calc(100vh - 100px)',
    backgroundColor: theme.palette.grey[50],
    minWidth: '500px',
    maxWidth: '500px',
});

export const Wrapper = styled.div<{ greaterThanMid: boolean; hasBanner: boolean; hasRightPanel?: boolean }>`
    display: flex;
    flex-direction: ${({ greaterThanMid }) => (greaterThanMid ? 'row' : 'column-reverse')};
    background-color: ${themeLight.palette.grey[50]};
    position: relative;
    z-index: 1;
    width: 100%;

    ${({ greaterThanMid, hasBanner, hasRightPanel }) =>
        greaterThanMid
            ? hasRightPanel
                ? `
            justify-content: flex-start;
            align-items: flex-start;
            width: 100%;
            height: auto;
            overflow: visible;
          `
                : hasBanner
                  ? `
            justify-content: flex-start;
            align-items: flex-start;
            width: 60vw;
            margin: 0;
            height: auto;
            overflow: visible;
          `
                  : `
            justify-content: center;
            align-items: flex-start;
            width: 100vw;
            min-height: 100vh;
            overflow: visible;
          `
            : `
        justify-content: flex-start;
        align-items: flex-start;
        overflow: visible;
        height: auto;
      `}
`;
